var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import useRegistrationForm from "../../../../../hooks/useRegistrationForm";
export var enrichRegistrationFormPropsMsdCtio = function () {
    var _a = useRegistrationForm(), eventCountries = _a.eventCountries, contents = _a.contents, allCountries = _a.allCountries, languages = _a.languages, getRegistrationFormProps = _a.getRegistrationFormProps, hasInternal = _a.hasInternal, getTranslatedOptions = _a.getTranslatedOptions, isInternalUser = _a.isInternalUser, specialtyInputValue = _a.specialtyInputValue;
    var _b = contents, error_email_invalid = _b.error_email_invalid, error_lastname_required = _b.error_lastname_required, error_firstname_required = _b.error_firstname_required, error_country_required = _b.error_country_required, error_language_required = _b.error_language_required, error_email_required = _b.error_email_required, email = _b.email, country_of_work = _b.country_of_work, affiliation = _b.affiliation, language = _b.language, internal = _b.internal, internal_false_value_label = _b.internal_false_value_label, firstname = _b.firstname, lastname = _b.lastname, country = _b.country, specialty = _b.specialty, otherSpecialty = _b.otherSpecialty, internal_true_value_label = _b.internal_true_value_label;
    var inputs = [];
    var languageInput = {
        type: "hidden",
        name: "lang_id",
        value: languages[0].value
    };
    if (languages.length > 1) {
        languageInput = {
            type: "select",
            label: language,
            required: true,
            name: "lang_id",
            rules: [
                {
                    required: true,
                    message: error_language_required
                }
            ],
            options: languages
        };
    }
    inputs.push(languageInput);
    if (hasInternal) {
        var is_internal_options = [
            {
                value: "ext",
                label: internal_true_value_label
            },
            {
                value: "int",
                label: internal_false_value_label
            }
        ];
        inputs.push({
            type: "select",
            id: "is_internal",
            name: "is_internal",
            required: true,
            label: internal,
            options: is_internal_options
        });
    }
    var countriesInput = {
        label: country_of_work,
        name: "country_id_of_work",
        options: allCountries,
        required: true,
        type: "select",
        rules: [
            {
                required: true,
                message: error_country_required
            }
        ]
    };
    if (!isInternalUser) {
        countriesInput = {
            label: country,
            name: "country_id",
            options: eventCountries,
            required: true,
            type: "select",
            rules: [
                {
                    required: true,
                    message: error_country_required
                }
            ]
        };
    }
    inputs.push(countriesInput);
    inputs = __spreadArray(__spreadArray([], inputs, true), [
        {
            type: "text",
            name: "firstname",
            label: firstname,
            rules: [
                {
                    required: true,
                    message: error_firstname_required
                }
            ]
        },
        {
            type: "text",
            name: "lastname",
            required: true,
            label: lastname,
            rules: [
                {
                    required: true,
                    message: error_lastname_required
                }
            ]
        },
        {
            label: specialty,
            name: "specialty",
            options: getTranslatedOptions(),
            required: true,
            type: "select",
            rules: [
                {
                    required: true,
                    message: "Please input your speciality!"
                }
            ]
        }
    ], false);
    if (specialtyInputValue === "Other") {
        inputs.push({
            type: "text",
            label: otherSpecialty,
            required: true,
            name: "other_specialty",
            rules: [
                {
                    required: true,
                    message: "Please input your other speciality!"
                }
            ]
        });
    }
    inputs = __spreadArray(__spreadArray([], inputs, true), [
        {
            label: affiliation,
            name: "affiliation",
            required: true,
            type: "text",
            rules: [
                {
                    required: true,
                    message: "Please input your affiliation!"
                }
            ]
        },
        {
            label: email,
            name: "email",
            required: true,
            type: "email",
            rules: [
                { type: "email", message: error_email_invalid },
                {
                    required: true,
                    message: error_email_required
                }
            ]
        }
    ], false);
    return getRegistrationFormProps({ inputs: inputs });
};
